import { isBefore } from 'date-fns'
import * as React from 'react'
import CalendarMonth from '../CalendarMonth'
import { NumberOrRange } from '../CalendarMonth/CalendarMonth'
import EasterEgg from '../CalendarMonth/EasterEgg'
import { ActionListHeader, CalendarHeader } from './Header'

import { Loader } from 'components/Preloader'
import './Calendar.scss'

const MONTH_NAMES = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
]

interface CalendarProps {
  year: number
  month: number
  selectedDay?: number
  cheapestDay?: number
  dayCell: JSX.Element
  actionList?: boolean
  icon?: string
  onDaySelect?: (NumberOrRange: NumberOrRange) => any
  onMonthChange: (year: number, month: number) => any
  loading?: boolean
  staticHeight?: boolean
  disableLeftButton?: boolean
  disableRightButton?: boolean
  showEasterEgg?: boolean
  onEasterEggComplete?: () => void
}

class Calendar extends React.Component<CalendarProps, {}> {
  constructor(props: CalendarProps) {
    super(props)
    this.onMonthChange = this.onMonthChange.bind(this)
  }

  public onMonthChange(delta: number) {
    const newDate = new Date(this.props.year, this.props.month - 1 + delta, 1)
    this.props.onMonthChange(newDate.getFullYear(), newDate.getMonth() + 1)
  }

  public render() {
    const monthName = MONTH_NAMES[this.props.month - 1] || ``
    const { year, disableLeftButton, disableRightButton, icon } = this.props
    const headerProps = {
      day: this.props.selectedDay,
      monthName,
      year,
      onClickLeft: () => this.onMonthChange(-1),
      onClickRight: () => this.onMonthChange(1),
      disableLeftButton,
      disableRightButton,
      icon,
    }
    return (
      <div
        className={
          'srprs-calendar' + (this.props.staticHeight ? ' static-height' : '')
        }
      >
        <Loader hidden={!this.props.loading} />
        {this.props.actionList ? (
          <ActionListHeader {...headerProps} />
        ) : (
          <CalendarHeader {...headerProps} />
        )}
        {this.props.showEasterEgg && this.isBefore() ? (
          <EasterEgg onComplete={this.props.onEasterEggComplete} />
        ) : (
          <CalendarMonth
            year={this.props.year}
            month={this.props.month}
            allowSelection={true}
            dayCell={this.props.dayCell}
            selectedDay={this.props.selectedDay}
            cheapestDay={this.props.cheapestDay}
            onDaySelect={this.props.onDaySelect}
          />
        )}
      </div>
    )
  }

  private isBefore = () => {
    const date = new Date(this.props.year, this.props.month - 1, 1)
    const currentDate = new Date()
    const currentFirstMonth = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      1,
    )
    return isBefore(date, currentFirstMonth)
  }
}

export default Calendar
